import React, { useState } from 'react';
import '../css/contactanos.css';
import Navbar from '../components/common/Navbar/Navbar';
import Footer from '../components/common/Footer/Footer';
import { API_BASE } from '../config/apiConfig';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success', 'error', null

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${API_BASE}/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error sending contact form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoToApp = () => {
    if (window.location.hostname === 'localhost') {
      window.location.href = 'http://localhost:3000/';
    } else {
      window.location.href = '/app/';
    }
  };

  const handleGoToRegister = () => {
    if (window.location.hostname === 'localhost') {
      window.location.href = 'http://localhost:3000/register';
    } else {
      window.location.href = '/app/register';
    }
  };

  return (
    <div className="App">
      <Navbar onGoToApp={handleGoToApp} onGoToRegister={handleGoToRegister} />
      
      {/* Background Image Container */}
      <div className="contact-background-container">
        <img 
          src="/images/contact/contactUs.png" 
          alt="Contact Background" 
          className="contact-background-image"
        />
        
        {/* Contactanos Section */}
        <section id="contact" className="contactanos-section">
          <div className="section-container">
            <form onSubmit={handleSubmit} className="writeus-container">
              <div className="writeus-title-container">
                <h2 className="writeus-title writeus-title-typography">Contáctanos</h2>
              </div>
              
              {submitStatus === 'success' && (
                <div style={{ 
                  position: 'absolute', 
                  top: '10%', 
                  left: '50%', 
                  transform: 'translateX(-50%)',
                  background: '#4CA93A',
                  color: 'white',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  zIndex: 10
                }}>
                  ¡Mensaje enviado exitosamente!
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div style={{ 
                  position: 'absolute', 
                  top: '10%', 
                  left: '50%', 
                  transform: 'translateX(-50%)',
                  background: '#f44336',
                  color: 'white',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  zIndex: 10
                }}>
                  Error al enviar el mensaje. Inténtalo de nuevo.
                </div>
              )}

              <div className="writeus-name-container">
                <input 
                  type="text" 
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Nombre" 
                  className="writeus-name-input writeus-text-typography"
                  required
                />
              </div>
              
              <div className="writeus-subject-container">
                <input 
                  type="text" 
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  placeholder="Asunto" 
                  className="writeus-subject-input writeus-text-typography"
                  required
                />
              </div>
              
              <div className="writeus-email-container">
                <input 
                  type="email" 
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Correo electrónico" 
                  className="writeus-email-input writeus-text-typography"
                  required
                />
              </div>
              
              <div className="writeus-message-container">
                <textarea 
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Mensaje" 
                  className="writeus-message-input writeus-text-typography"
                  required
                ></textarea>
              </div>
              
              <div className="writeus-send-container">
                <button 
                  type="submit"
                  className="writeus-send-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar'}
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Contact; 